import { connect } from 'react-redux'
import View from './view'

export default connect((model: any) => {
  return { ...model.carOwner }
})(View)
